<script>
import mediaCenter from "./media-center";
export default {
  name: "Identity",
  extends: mediaCenter
};
</script>

